<template>
  <div>
    <div class="titileDefinition">活动数据</div>
    <div class="linerHeight"></div>
    <div class="section-right-content-box">
      <div style="margin: 20px 0px 20px 0px">
        <el-form label-width="10px">
          <el-form-item>
            <span style="margin-right: 20px">统计时间 :</span>
            <el-radio
              v-model="queryForm.evaluateTime"
              @change="timeChange"
              v-for="item in options.evaluateTimeOpt"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="postForm.startDate"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                :disabled="
                  queryForm.evaluateTime != 0 || !queryForm.evaluateTime
                "
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div
                class="time_to_text"
                :class="{
                  to_text_disabled:
                    queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
                }"
              >
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="postForm.endDate"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                :disabled="
                  queryForm.evaluateTime != 0 || !queryForm.evaluateTime
                "
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="true"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearTimeSendTime()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt
                class="date_icon2"
              />
            </div>
            <el-button
              class="b1"
              style="margin-left: 20px"
              v-zoom='{from:"忠诚度管理-数据分析-活动数据",name:"查询"}'
              @click="queryTotal()"
              ><span style="marginleft: 4px">
                <i
                  class="el-icon-search"
                  style="
                    display: inline-block;
                    width: 14px;
                    height: 12px;
                    fontweight: bold;
                    margin-right: 4px;
                  "
                ></i
                >查询</span
              ></el-button
            >
            <el-button class="b2" style="margin-left: 20px" @click="queryOne()"
              ><span style="marginleft: 4px">重置</span></el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <div class="background">
        <span class="title"></span>&nbsp;
        <span class="tips">数据总览</span>
      </div>
      <div v-loading="loading">
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">活动PV</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="活动页面访问次数，刷新一次或点击一次都算一次PV流量。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <!-- <i class="iconfont iconbtn_yiwen"></i> -->
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.activityPv }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">活动UV</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="活动页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.activityUv }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">活动中心首页PV</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="会员中心首页访问次数，刷新一次或点击一次都算一次PV流量。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.pv }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">活动中心首页UV</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="会员中心首页页面访问人数，指访问某个站点或点击某个网页的不同IP地址的人数。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.uv }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">参与人数</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="参与活动的人数。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.joinNumber }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">新增人数</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="参与活动的新增人数；以近7天为例，之前没有参与过活动，近七天参与过的新客户就属于新增人数。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.incrFollowNumber }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">参与次数</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="参与活动的次数。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.joinTimes }}</div>
        </div>
        <div class="overview1" style="float: left">
          <div>
            <span class="fontClass">人均参与次数</span>
            <el-popover
              placement="top-start"
              width="200"
              offset="100"
              trigger="hover"
              content="参与次数/参与人数。"
            >
              <span style="float: right; margin-top: -10px" slot="reference">
                <i class="iconfont iconbtn_yiwen"></i>
              </span>
            </el-popover>
          </div>
          <div class="num">{{ this.tableTotal.perCapitaTimes }}</div>
        </div>
      </div>

      <div
        style="clear: left"
        ref="payRemindChart"
        class="chart"
        v-loading="loading"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import echarts from "echarts";
import {
  getChartEffectDetails,
  getSumEffectDetails,
} from "@/api/integralCenter/PointActivityAnalyticController";
export default {
  data() {
    return {
      messageOne: "流量分析",
      messageTwo: "活动数据",
      messageThree: "奖品统计",
      topSelect: 1,
      tabActiveIndex: 1,
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      //折线图数据
      myCharts: null,
      tableTotal: [],
      chartEffectDetail: {
        homePagePv: [], //会员中心首页PV
        homePageUv: [], //会员中心首页uv
        incrJoinNumber: [], //参与人数今日增量
        joinNumber: [], //参与人数
        joinTimes: [], //参与人次
        perCapitaTimes: [], //人均参与次数
        pv: [], //页面浏览数
        statsDate: [], // 统计日期
        uv: [], //页面访问人数
      },

      queryForm: {
        evaluateTime: "30",
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      countTable: [],
      loading: true,
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "15",
            label: "近15天",
          },
          {
            value: "30",
            label: "近30天",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  created() {
    this.timeChange(30);
    this.queryTotal();
  },
  mounted() {
    // this.nextTick();
  },
  methods: {
    hugItemBtn(type) {
      this.topSelect = type;
    },
    //查询数据总和
    queryTotal() {
      console.log(this.postForm.startDate);
      console.log(this.postForm.endDate);
      this.loading = true;
      getSumEffectDetails({
        startTime: this.postForm.startDate,
        endTime: this.postForm.endDate,
      })
        .then((res) => {
          this.loading = false;
          this.tableTotal = res.data;
          console.log(this.postForm.endDate);
        })
        .catch((res) => {
          this.$message.error("输入时间错误");
        });

      //折线图数据查询
      getChartEffectDetails({
        startTime: this.postForm.startDate,
        endTime: this.postForm.endDate,
      })
        .then((res) => {
          if (res.data.length == 1 && res.data.length == 0) {
            this.$message.error("折线图时间过短");
          } else if (res.data.length > 1) {
            var dataList = res.data;
            // console.log(dataList);
            var homePagePvList = []; //活动中心首页PV
            var homePageUvList = []; //活动中心首页uv
            var incrJoinNumberList = []; //新增人数
            var joinNumberList = []; //参与人数
            var joinTimesList = []; //参与人次
            var perCapitaTimesList = []; //人均参与次数
            var pvList = []; //pv
            var statsDateList = []; // 统计日期
            var uvList = []; //uv
            dataList.forEach((item) => {
              homePagePvList.push(item.pv);
              homePageUvList.push(item.uv);
              incrJoinNumberList.push(item.newAddNumber);
              joinNumberList.push(item.joinNumber);
              joinTimesList.push(item.joinTimes);
              perCapitaTimesList.push(item.perCapitaTimes);
              pvList.push(item.activityPv);
              statsDateList.push(item.statsDate);
              uvList.push(item.activityUv);
            });
            this.chartEffectDetail = {
              pv: homePagePvList, //会员中心首页PV
              uv: homePageUvList, //会员中心首页uv
              newAddNumber: incrJoinNumberList, //参与人数今日增量
              joinNumber: joinNumberList, //参与人数
              joinTimes: joinTimesList, //参与人次
              perCapitaTimes: perCapitaTimesList, //人均参与次数
              activityPv: pvList, //页面浏览数
              statsDate: statsDateList, // 统计日期
              activityUv: uvList, //页面访问人数
            };
          }
          this.$nextTick(() => {
            this.initChart();
            window.addEventListener("resize", () => {
              this.myCharts.resize();
            });
          });
          // console.log(this.chartEffectDetail);
          // console.log(this.chartEffectDetail.homePagePv);
          // console.log(this.chartEffectDetail.homePageUv);
          // console.log(this.chartEffectDetail.incrJoinNumber);
          // console.log(this.chartEffectDetail.joinNumber);
          // console.log(this.chartEffectDetail.joinTimes);
          // console.log(this.chartEffectDetail.perCapitaTimes);
          // console.log(this.chartEffectDetail.pv);
          // console.log(this.chartEffectDetail.statsDate);
        })
        .catch((res) => {
          this.$message.error("输入时间错误");
        });
    },
    //折线图
    initChart() {
      this.myCharts = echarts.init(this.$refs.payRemindChart);
      this.setOptions(this.chartEffectDetail);
      // console.log(this.chartEffectDetail);
    },
    //折线图事件
    setOptions({
      pv,
      uv,
      newAddNumber,
      joinNumber,
      joinTimes,
      perCapitaTimes,
      activityPv,
      statsDate,
      activityUv,
    } = {}) {
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [
            "活动PV",
            "活动UV",
            "活动中心首页PV",
            "活动中心首页UV",
            "参与人数",
            "新增人数",
            "参与次数",
            "人均参与次数",
          ],
          bottom: -5,
          left: 60,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: statsDate,
        },
        yAxis: {
          type: "value",
           axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            name: "活动PV",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#7F85E9",
            data: activityPv,
          },
          {
            name: "活动UV",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#5882FB",
            data: activityUv,
          },
          {
            name: "活动中心首页PV",
            type: "line",
            color: "#FF872F",
            areaStyle: {},
            smooth: true,
            data: pv,
          },
          {
            name: "活动中心首页UV",
            type: "line",
            color: "#FE4D45",
            areaStyle: {},
            smooth: true,
            data: uv,
          },
          {
            name: "参与人数",
            type: "line",
            color: "#FFC400",
            areaStyle: {},
            smooth: true,
            data: joinNumber,
          },
          {
            name: "新增人数",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#FF938E",
            data: newAddNumber,
          },
          {
            name: "参与次数",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#4CDFC0",
            data: joinTimes,
          },
          {
            name: "人均参与次数",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#8693CB",
            data: perCapitaTimes,
          },
        ],
      };

      this.myCharts.setOption(option);
    },

    //重置
    queryOne() {
      this.queryForm.evaluateTime = "7";
      this.timeChange(30);
      this.queryTotal();
    },
    //查询我的分组
    handleClick(type) {
      this.tabActiveIndex = 2;
      this.topSelect = type;
      this.queryList();
    },
    handleClick2(type) {
      this.tabActiveIndex = 3;
      this.topSelect = type;
      this.queryList();
    },
    handleClick0(type) {
      this.tabActiveIndex = 1;
      this.topSelect = type;
      this.queryList();
    },
    //时间限制
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },
    timeChange(type) {
      let self = this;
      let hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      console.log(date);
      if (type == null) {
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 7) {
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 15) {
        this.mytime[0] = self.getDay(-15, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.titileDefinition {
  min-width: 1046px;
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  margin: 20px 20px 0 20px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  font-size: 16px;
  color: #2e3458;
  font-weight: bold;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
}

.section-right-content-box {
  min-width: 1046px;
  border-bottom: 6px;
  padding: 15px 28px 30px 28px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 20px 20px 20px;
  .tabList {
    display: flex;
    box-sizing: border-box;
    height: 36px;
    line-height: 35px;
    // margin-top: 20px;
    color: #666;
    font-size: 14px;
    margin: 20px 0;
    span {
      margin-right: 3px;
      width: 106px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      vertical-align: middle;
      transform: perspective(1px) translateZ(0);
      box-shadow: 0 0 1px rgba(0, 0, 0, 0);
      border-radius: 2px 2px 0px 0px;
      border: 1px solid #dddddd;
      text-align: center;
    }
    .active {
      position: relative;
      transition: all 0.2s;
      color: #fe4d45;
      border-bottom: none;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        top: 0;
        height: 2px;
        background: #fe4d45;
        border-radius: 6px 6px 0px 0px;
      }
    }
    i {
      flex: 1;
      border-bottom: 1px solid #dddddd;
      margin-left: -3px;
    }
  }
  .b1 {
    width: 98px;
    height: 32px;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    color: #666666;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .background {
    height: 32px;
    background: rgba(250, 250, 250, 1);
    opacity: 1;
    line-height: 32px;
    padding-left: 12px;
    .title {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: rgba(254, 77, 69, 1);
      opacity: 1;
      border-radius: 3px;
      vertical-align: middle;
    }
    .tips {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      vertical-align: middle;
    }
  }

  .overview1 {
    padding: 26px 30px 22px 30px;
    width: 182px;
    height: 100px;
    border-right: 1px solid #f3f3f3;
    opacity: 1;
    margin: 20px 0px;
    .fontClass {
      width: 102px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(102, 102, 102, 1);
      opacity: 1;
    }
    .iconbtn_yiwen{
      color:#cccccc;font-size:13px;
      &:hover{
        color:#fe4d45;
      }
    }
    .question_icon {
      width: 14px;
      height: 14px;
      color: #cccccc;
      display: inline-block;
      line-height: 12px;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #cccccc;
      font-size: 12px;
      font-weight: normal;
    }
    .num {
      width: 65px;
      height: 29px;
      font-size: 24px;
      font-family: DIN;
      font-weight: bold;
      line-height: 29px;
      color: rgba(254, 77, 69, 1);
      opacity: 1;
      margin-top: 14px;
      margin-bottom: 30px;
    }
  }
  .chart {
    // flex: 1;
    height: 380px;
    min-width: 1000px;
  }
}
</style>